import {createSelector} from 'reselect';

const getConfig = state => state.pageState.layout.config;
const getKiosk = state => state.pageState.explorerMap;

const getEvents = createSelector(
    [getConfig, getKiosk],
    ({events}, {navigation}) =>
        events?.filter(
            event =>
                event.feature &&
                event.feature?.properties?.locationId === navigation.item?.properties?.locationId
        ) || []
);

export default getEvents;
